import { useEffect } from 'react';

export default function CalendarSection() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="calendar" className="py-12 md:py-20 bg-[#0a0a0a]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-center mb-4 tracking-tight leading-tight">
          SCHEDULE YOUR STRATEGY SESSION
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-400 text-center mb-8 max-w-3xl mx-auto px-2">
          Book a call directly with the KKOS Lawyers team. Complimentary for Epic Real Estate viewers. Tell them Matt sent you.
        </p>

        <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-2 sm:p-4 md:p-8">
          <div
            className="calendly-inline-widget w-full"
            data-url="https://calendly.com/new-client-specialists/15-minute-referral-interview-clone"
            style={{ minWidth: '280px', height: '1300px' }}
          />
        </div>
      </div>
    </section>
  );
}
